import { useEffect, useState } from "react";
import { useToast } from "@chakra-ui/react";

import { chainSubscribeKeyMapping, validateEmail } from "@utils/common";
import { trackEvent } from "dapp-sdk-v2";
import { NEWSLETTER } from "@constants/analytics";

import usePageData from "@hooks/usePageData";
import SubscribeCard from "@components/SubscribeCard";

import { subscribeToEmail } from "./subscribe.service";

const token = process.env.NEXT_PUBLIC_TOKEN;

const Subscribe = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState<undefined | string>();
  const [isSubscribing, setIsSubscribing] = useState(false);
  const toast = useToast();

  const subscribeData =
    usePageData(
      "$.page.data.right_sections.data[?(@.attributes.key=='subscription')]"
    )[0]?.attributes || {};

  useEffect(() => {
    if (email) {
      const isValidEmail = validateEmail(email);
      if (isValidEmail) {
        setError(undefined);
      } else {
        setError("Please enter correct email ID");
      }
    }
  }, [email]);

  const subscribe = () => {
    if (!email || !email?.trim()) {
      setError("Email is required");
      return;
    }

    if (!validateEmail(email)) {
      setError("Please enter correct email ID");
      return;
    }

    setIsSubscribing(true);

    trackEvent(NEWSLETTER, {
      email: email,
    });

    // const formData: any = new FormData();
    if (token && chainSubscribeKeyMapping[token]) {
      // formData.append("Email", email);
      // formData.append(chainSubscribeKeyMapping[token], true);
      const data = {
        email,
        networks: [chainSubscribeKeyMapping[token]],
      };

      subscribeToEmail(data)
        .then(() => {
          setEmail("");
          setError(undefined);
          toast({
            description:
              subscribeData?.content?.[0]?.data?.[0]?.success_message ||
              "Email subscribed successfully",
            status: "success",
            duration: 2000,
            position: "top",
          });
        })
        .catch((error) => {
          const errorMessage =
            error?.message ||
            subscribeData?.content?.[0]?.data?.[0]?.fallback_error_message ||
            "Failed to subscribe";
          toast({
            description: errorMessage,
            status: "error",
            duration: 2000,
            position: "top",
          });
        })
        .finally(() => {
          setIsSubscribing(false);
        });
    }
  };

  return (
    <SubscribeCard
      title={subscribeData?.title}
      subTitle={subscribeData?.sub_title || ""}
      email={email}
      onChangeEmail={(value) => setEmail(value)}
      error={error}
      onSubscribe={() => subscribe()}
      isSubscribing={isSubscribing}
      placeholder={
        subscribeData?.content?.[0]?.data?.[0]?.placeholder ||
        "Enter emailll address"
      }
    />
  );
};

export default Subscribe;
